import { iOSWrapperApp } from 'utils/constants/swarm/spring-configs';

export const deviceActionManager = {
  vibrate: handleHapticFeedback
  //Can add more managers here
};

function handleHapticFeedback(
  message: 'impactLight' | 'impactMedium' | 'impactHeavy'
) {
  const hapticMessage = { type: message };

  if (iOSWrapperApp) {
    window?.webkit?.messageHandlers?.triggerHaptic.postMessage(hapticMessage);
  } else {
    if (window.triggerHaptic) {
      window.triggerHaptic.postMessage(JSON.stringify(hapticMessage));
    }
  }
}
